import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

interface IInputField {
  readOnly?: boolean;
  placeholder?: string;
  type?:
    | "text"
    | "password"
    | "email"
    | "number"
    | "url"
    | "tel"
    | "search"
    | "date"; // Restricting to specific input types
  value?: string;
  onChange?: (value: string) => void;
  label?: string;
  id?: string; // Adding an id prop for accessibility
  onInput?: (e: any) => void;
  maxLength?: number; // Adding maxLength prop
  max?: string;
}

const InputField: React.FC<IInputField> = ({
  readOnly = false,
  placeholder = "",
  type = "text", // Defaulting to "text"
  value = "",
  onChange = () => {},
  label = "",
  id = "",
  onInput,
  maxLength,
  max,
}) => {
  const [inputType, setInputType] = useState(type);

  const togglePasswordVisibility = () => {
    setInputType((prevType) => (prevType === "password" ? "text" : "password"));
  };

  return (
    <div>
      {label && (
        <label
          className="font-Poppins-Medium text-white font-size-16px"
          htmlFor={id}
        >
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={id}
          className="input-fields input-field-margin-top input-btns-height-50px w-full bg-[#FFFFFF] outline-none font-Poppins-SemiBold font-size-16px theme-color-green"
          placeholder={placeholder}
          type={inputType}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          readOnly={readOnly}
          onInput={onInput}
          maxLength={maxLength}
          max={max}
        />
        {type === "password" && (
          <FontAwesomeIcon
            id="toggle-password"
            // style={{ marginTop: "0.2rem" }}
            icon={inputType === "password" ? faEyeSlash : faEye}
            onClick={togglePasswordVisibility}
            className="absolute lg:right-[0.5vw] right-[0.2rem] top-1/2 transform font-size-18px text-[#004540] -translate-y-1/2 cursor-pointer"
          />
        )}
      </div>
    </div>
  );
};

export default InputField;
